// Number formatters shared by the EEX pages. Accept number | string | null so
// they work over both the numeric ledger values and the string-decimal API
// fields. (Phase 4 will route every existing call site through these.)

type Num = number | string | null | undefined;

function toNum(v: Num): number | null {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

// EUR with 2 decimals, en-US separators.
export function fmtEur2(v: Num): string {
  const n = toNum(v);
  return n == null ? "—" : n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// EUR rounded to whole units.
export function fmtEur0(v: Num): string {
  const n = toNum(v);
  return n == null ? "—" : Math.round(n).toLocaleString("en-US");
}

// Price / settlement value to a fixed number of decimals (default 3).
export function fmtPx(v: Num, digits = 3): string {
  const n = toNum(v);
  return n == null ? "—" : n.toFixed(digits);
}

// Plain quantity / MWh with en-US separators.
export function fmtQty(v: Num): string {
  const n = toNum(v);
  return n == null ? "—" : n.toLocaleString("en-US");
}
